export default {
  OS: {
    DATE: {
      TIMEZONE: 'America/New_York',
      STRING_INPUT_FORMAT: 'MM/dd/yyyy',
      STRING_OUTPUT_FORMAT: 'yyyy-MM-dd'
    }
  }
};